import "./App.css";
import Home from "./Home";
import { UserProvider } from "./Components/Quetionary/ContextAPI";
import { GlobalStyles, Snackbar, Alert } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import StateProviders from "./context/StateProviders";
import { get } from "./utils/api";
import useInactivityLogout from "./hooks/useInactivityLogout";
// import socket from "./socket";

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    if (localStorage.getItem("loggedOut") === "true") {
      sessionStorage.clear();
      // optional: remove the flag to allow next login
      localStorage.removeItem("loggedOut");
      navigate("/login");
    }
  }, []);

  //  Clickjacking Protection
  useEffect(() => {
    if (window.top !== window.self) {
      document.body.innerHTML = "";
      alert("This page cannot be embedded in an iframe!");
    }
  }, []);

  useInactivityLogout({
    onWarning: () =>
      setSnackOpen({
        open: true,
        message: "You will be logged out in 5 minute due to inactivity.",
        severity: "warning",
      }),
  });

  // useEffect(async () => {
  //   const token = sessionStorage.getItem("token");
  //   const res = await get(`/api/auth/maintaince`);
  //   const { maintainceMode } = res.data;
  //   console.log(maintainceMode, "value for maintainceMode");
  //   if (maintainceMode) {
  //     navigate("/maintenance");
  //   } else if (
  //     !token &&
  //     !location.pathname.startsWith("/reset-password") &&
  //     !location.pathname.startsWith("/create-password") &&
  //     !location.pathname.startsWith("/policy") &&
  //     !location.pathname.startsWith("/terms-&-services")
  //   ) {
  //     // navigate("/maintenance");
  //     navigate("/login");
  //   }
  // }, [location.pathname]);

  useEffect(() => {
    const checkMaintenanceMode = async () => {
      const token = sessionStorage.getItem("token");

      try {
        const res = await get(`/api/auth/maintaince`);
        const { maintainceMode } = res.data;

        if (maintainceMode) {
          if (location.pathname !== "/maintenance") {
            navigate("/maintenance", { replace: true });
          }
        } else if (
          !token &&
          !location.pathname.startsWith("/reset-password") &&
          !location.pathname.startsWith("/create-password") &&
          !location.pathname.startsWith("/sso-success") &&
          !location.pathname.startsWith("/sso-failure") &&
          !location.pathname.startsWith("/policy") &&
          !location.pathname.startsWith("/terms-&-services")
        ) {
          if (location.pathname !== "/login") {
            navigate("/login", { replace: true });
          }
        } else if (location.pathname === "/maintenance") {
          navigate("/dashboard", { replace: true });
        }
        // ✅ Do nothing if no change needed
      } catch (err) {
        console.error("Error checking maintenance mode:", err);
      }
    };

    checkMaintenanceMode();
  }, [location.pathname]);

  // useEffect(() => {
  //   // When socket connects
  //   socket.on("connect", () => {
  //     console.log("✅ Connected:", socket.id);
  //   });

  //   // Disconnect handler
  //   socket.on("disconnect", (reason) => {
  //     console.log("❌ Disconnected:", reason);
  //     // Optional: show UI indicator or update state
  //   });

  //   // Reconnect handler
  //   socket.on("reconnect", (attempt) => {
  //     console.log(`✅ Reconnected after ${attempt} attempts`);
  //   });

  //   // Heartbeat from server
  //   socket.on("heartbeat", (data) => {
  //     console.log("socket connected", data);
  //   });

  //   // Chat messages
  //   socket.on("receive_message", (data) => {
  //     console.log("📩 Message:", data);
  //   });
  //   socket.on("pdfGenerated", (data) => {
  //     let count = 0;
  //     console.log("pdf-------genearated work", count);
  //     if (data?.fileData) {
  //       const byteArray = new Uint8Array(data.fileData);
  //       const blob = new Blob([byteArray], { type: "application/pdf" });
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement("a");
  //       a.href = url;
  //       a.download = data.fileName || "GRI_Report.pdf";
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //       window.URL.revokeObjectURL(url);
  //       count++;
  //     }
  //   });

  //   socket.on("pdfGeneratedError", (data) => {
  //     console.error("PDF Error:", data);
  //     alert("Error generating PDF. Please try again.");
  //   });
  //   let counter = 0;
  //   socket.on("pdfGenerated1", (data) => {
  //     console.log("pdfGenerated1pdfGenerated1pdfGenerated1", counter);
  //     counter++;
  //   });

  //   // Cleanup on unmount
  //   return () => {
  //     [
  //       "connect",
  //       "disconnect",
  //       "reconnect",
  //       "heartbeat",
  //       "pdfGenerated",
  //       "pdfGeneratedError",
  //       "receive_message",
  //     ].forEach((event) => socket.off(event));
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <div className="App">
      <GlobalStyles
        styles={{
          html: {
            scrollBehavior: "smooth",
            "-webkit-overflow-scrolling": "touch",
            overscrollBehavior: "none",
          },
          body: {
            overscrollBehavior: "none",
            margin: 0,
            padding: 0,
            overflow: "hidden", // Disable body scroll
          },
          "@supports (-ms-ime-align: auto)": {
            body: {
              overflowY: "hidden",
            },
            ".scrollable-container": {
              overflowY: "auto",
            },
          },
        }}
      />
      <StateProviders>
        <UserProvider>
          <Home />
        </UserProvider>
      </StateProviders>
      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message} // Optional, since you're using <Alert> for the message
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setSnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity || "info"} // Ensure a default severity if undefined
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message || "No message provided"}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default App;
